import { css, html, LitElement } from "lit"
import "@luminecence/composants/Icone"

export default class MenuBasPage extends LitElement {
  static properties = {
    cheminActif: { state: true },
  }

  constructor() {
    super()
    this.cheminActif = this.determinerCheminMenuActif(window.location.pathname)
  }

  connectedCallback() {
    super.connectedCallback()
    window.addEventListener("popstate", this.mettreAJourCheminActif)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener("popstate", this.mettreAJourCheminActif)
  }

  static styles = css`
    .menu {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
      height: calc(var(--hauteur-menu-bas) + env(safe-area-inset-bottom));
        background: var(--couleur-fond);
        display: flex;
        justify-content: space-around; /* Répartition égale des 3 boutons */
        align-items: stretch;
        border-top: 2px solid var(--couleur-600); /* Jaune Pokémon pour le rappel visuel */
      padding-bottom: env(safe-area-inset-bottom);
      box-sizing: border-box;
      overflow: hidden;
      z-index: 1100;
        box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
    }

    .menuObjet {
        flex: 1; /* Chaque bouton prend 1/4 de l'espace */
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        text-decoration: none;
        color: var(--couleur-texte);
        font-family: sans-serif;
        transition: all 0.2s ease;
    }

    .menuObjet.actif {
        background-color: var(--couleur-300);
        font-weight: bold;
    }

    .icon {
        font-size: 22px;
        margin-bottom: 4px;
    }

    .label {
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    p-icone {
        --icone-taille: 22px;
        --icone-couleur: var(--couleur-texte);
    }
    `

  render() {
    return html`
            <nav class="menu" aria-label="Menu de navigation principal">
                <a href="/recherche" class=${this.determinerClasseItem("/recherche")} aria-current=${this.determinerAriaCurrent("/recherche")} @click=${this.gererClicLien}>
                    <span class="icon">🔍</span>
                    <span class="label">Recherche</span>
                </a>
                <a href="/communaute" class=${this.determinerClasseItem("/communaute")} aria-current=${this.determinerAriaCurrent("/communaute")} @click=${this.gererClicLien}>
                    <span class="icon">👥</span>
                    <span class="label">Communauté</span>
                </a>
                <a href="/news" class=${this.determinerClasseItem("/news")} aria-current=${this.determinerAriaCurrent("/news")} @click=${this.gererClicLien}>
                    <span class="icon">📣</span>
                    <span class="label">News</span>
                </a>
                <a href="/conversations" class=${this.determinerClasseItem("/conversations")} aria-current=${this.determinerAriaCurrent("/conversations")} @click=${this.gererClicLien}>
                    <p-icone .icone=${"message"} ></p-icone>
                    <span class="label">Messages</span>
                </a>
            </nav>
        `
  }

  normaliserChemin(chemin) {
    if (!chemin || chemin === "/") return "/"
    return chemin.endsWith("/") ? chemin.slice(0, -1) : chemin
  }

  determinerCheminMenuActif(chemin) {
    const cheminNormalise = this.normaliserChemin(chemin)
    const cheminsMenu = ["/ma-recherche", "/communaute", "/news", "/conversations"]
    const cheminCorrespondant = cheminsMenu.find((cheminMenu) => {
      return cheminNormalise === cheminMenu || cheminNormalise.startsWith(`${cheminMenu}/`)
    })
    return cheminCorrespondant ?? ""
  }

  determinerAriaCurrent(cheminMenu) {
    return this.estCheminActif(cheminMenu) ? "page" : "false"
  }

  estCheminActif(cheminMenu) {
    return this.cheminActif === cheminMenu
  }

  determinerClasseItem(cheminMenu) {
    return this.estCheminActif(cheminMenu) ? "menuObjet actif" : "menuObjet"
  }

  mettreAJourCheminActif = () => {
    this.cheminActif = this.determinerCheminMenuActif(window.location.pathname)
  }

  gererClicLien(event) {
    this.cheminActif = this.determinerCheminMenuActif(event.currentTarget.getAttribute("href"))
  }
}
customElements.define("p-menu-bas-page", MenuBasPage)
